import React, { FunctionComponent, useEffect } from 'react';
import { FontIconInInput, SearchFilterBox } from '../FormElements/styles';
import { SearchInput } from './styles';
import { useTranslation } from 'react-i18next';
import { constantStrings } from '../../../constantStrings';
import { useHistory } from 'react-router';

interface SearchInterface {
    className?: string;
    searchFilterValue: string;
    setSearchFilterValue: Function;
    placeholder?: string | null;
    isFindBuildingsSearchBox?: boolean;
    isSearchboxSecondaryBorderRadius?: boolean;
    disableFilterPersistence?: boolean;
}

const SearchFilter: FunctionComponent<SearchInterface> = (props: SearchInterface) => {
    const history = useHistory();
    const { t } = useTranslation();

    const searchParams = new URLSearchParams(history.location.search);

    useEffect(() => {
        if (history.location.search && !disableFilterPersistence) {
            setSearchFilterValue(searchParams.get('search'));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const {
        searchFilterValue,
        setSearchFilterValue,
        placeholder,
        className,
        isFindBuildingsSearchBox,
        isSearchboxSecondaryBorderRadius,
        disableFilterPersistence
    } = props;

    useEffect(() => {
        !disableFilterPersistence &&
            history.replace({
                pathname: window.location.pathname,
                search: searchFilterValue ? `?search=${encodeURIComponent(searchFilterValue)}` : '',
                state: history.location.state
            });
    }, [searchFilterValue, history, disableFilterPersistence]);

    return (
        <SearchFilterBox
            className={'col-12 col-sm-8 col-md-6 col-lg-4 col-xl-3 ml-auto px-0 my-1 ' + className}
        >
            <SearchInput
                isFindBuildingsSearchBox={isFindBuildingsSearchBox}
                isSearchboxSecondaryBorderRadius={isSearchboxSecondaryBorderRadius}
                value={searchFilterValue || ''}
                onChange={(e: any) => setSearchFilterValue(e.target.value)}
                placeholder={placeholder || `${t(constantStrings.search)}...`}
            />
            {!searchFilterValue ? (
                <FontIconInInput
                    isThemeColor={isFindBuildingsSearchBox}
                    className='fa fa-search'
                    isLeftSide={true}
                ></FontIconInInput>
            ) : (
                <FontIconInInput
                    role='button'
                    tabIndex={0}
                    aria-label='clear text'
                    onClick={() => setSearchFilterValue('')}
                    onKeyPress={(e) => e.key === 'Enter' && setSearchFilterValue('')}
                    className={isFindBuildingsSearchBox ? ' ' : 'fa fa-times'}
                    isLeftSide={true}
                ></FontIconInInput>
            )}
        </SearchFilterBox>
    );
};
export default SearchFilter;
